/**Constants */
import { INTERNAL_THEME } from './constants';

export const isIE = () => {
  const userAgent = window.navigator.userAgent;
  
  // MSIE --> IE10 or older
  // Trident/ --> IE11
  return userAgent.includes('MSIE') || userAgent.includes('Trident/');
}

export const objectIsEmpty = (object) => {
  if (Object.keys(object).length === 0 && object.constructor === Object) {
    return true;
  }

  return false;
};

export const addThousandSeparator = (number, numberOfDigitsAfterDecimalPoint = 0) => {
  if (typeof number === "string") {
    return parseFloat(number.replace(",", ".")).toLocaleString("de-DE", {minimumFractionDigits: numberOfDigitsAfterDecimalPoint, maximumFractionDigits: numberOfDigitsAfterDecimalPoint});
  } else if (typeof number === "number") {
    return parseFloat(number).toLocaleString("de-DE", {minimumFractionDigits: numberOfDigitsAfterDecimalPoint, maximumFractionDigits: numberOfDigitsAfterDecimalPoint});
  }
}

export const addThousandSeparatorNoParse = (number, numberOfDigitsAfterDecimalPoint = 0) => {
  if (typeof number === "string") {
    //return number.replace(",", ".").toLocaleString("de-DE", {minimumFractionDigits: numberOfDigitsAfterDecimalPoint, maximumFractionDigits: numberOfDigitsAfterDecimalPoint});
    return parseFloat(number).toLocaleString("de-DE", {minimumFractionDigits: numberOfDigitsAfterDecimalPoint, maximumFractionDigits: numberOfDigitsAfterDecimalPoint});
  } else if (typeof number === "number") {
    return number.toLocaleString("de-DE", {minimumFractionDigits: numberOfDigitsAfterDecimalPoint, maximumFractionDigits: numberOfDigitsAfterDecimalPoint});
  }
}

export const roundToMultiple5 = (number, options) => {
  if ((number % 5) > 0) {
    if (options?.roundDown) {
      return number - (number % 5);
    } else {
      return number - (number % 5) + 5;
    }
  }

  return number;
}

export const filterTableForCurrentAmount = (table, currentAmount) => {
  return table.filter(item => {
    return item["ImpRich"] === currentAmount.toString();
  });
}

export const getParameterFromUrl = (parameter = null, queryParams = window.location.search) => {
  if(!parameter || !queryParams) return null;

  const params = new URLSearchParams(queryParams);

  return params.get(parameter);
}

export const flushUrlFromParameters = () => {
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname
  );

}

export const getCookie = (key) => {
  var match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
  
  if (match) {
    return match[2];
  }
  
  return "";
}

export const getMinMaxString = (min, max, options = {
  label: false,
  symbol: "",
  numberOfDigitsAfterDecimalPoint: 0
}) => {
  let result = [];

  if (addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint) === addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)) {
    const minMaxString = [`${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`];

    result = [...minMaxString];
  } else {
    let minMaxString = [];

    if (options.label) {
      minMaxString = [`da MIN ${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol} a MAX ${addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`];
    } else {
      minMaxString = [`da ${addThousandSeparator(min, options.numberOfDigitsAfterDecimalPoint)}${options.symbol} a ${addThousandSeparator(max, options.numberOfDigitsAfterDecimalPoint)}${options.symbol}`];
    }

    result = [...minMaxString];
  }
  
  return result;
}

export const getBaseLog = (number, base) => {
  return Math.log(number) / Math.log(base);
}

export const shiftRangeToZero = (min, max) => {
  const maxShiftedRangeLimit = max - min;
  
  return maxShiftedRangeLimit;
}

export const getCurrentValueFromPercentage = (min, max, percentage) => {
  const scaledMaxRangeLimit = shiftRangeToZero(min, max);
  const scaledCurrentValue = (scaledMaxRangeLimit * percentage);
  const currentValue = scaledCurrentValue + min;

  return currentValue;
}

export const getCurrentPercentageFromProgressBar = (currentValue, min, max) => {
  if (min !== max) {
    const scaledMaxRangeLimit = shiftRangeToZero(min, max);
    const scaledCurrentValue = currentValue - min;
  
    // return (scaledCurrentValue * 100) / scaledMaxRangeLimit;
    return (scaledCurrentValue) / scaledMaxRangeLimit;
  } else {
    return 0;
  }
}

export const convertRangeToLogarithmicRange = (min, max, logarithmBase) => {
  const logarithmicMinRangeLimit = getBaseLog(min, logarithmBase);
  const logarithmicMaxRangeLimit = getBaseLog(max, logarithmBase);
  
  return {
    logarithmicMinRangeLimit,
    shiftedMaxLogarithmicRangeLimit: shiftRangeToZero(logarithmicMinRangeLimit, logarithmicMaxRangeLimit),
  }
}

export const convertValueBasedOnLogaritmicScale = (progressBarData, options) => {
  const { currentValue, min, max, step } = progressBarData;
  const { logarithmBase, powBase = logarithmBase } = options;

  const percentage = getCurrentPercentageFromProgressBar(currentValue, min, max);

  // test con pinci
  const fakePercentage = (Math.pow(5, percentage) - 1) / (5 - 1); // trasformo la percentuale da 0.5 a un po' di meno cit. Pinci

  // const { logarithmicMinRangeLimit, shiftedMaxLogarithmicRangeLimit } = convertRangeToLogarithmicRange(min, max, logarithmBase);

  // Get the value on the logarithmic range based on the non-logarithmic percentage
  // const shiftedLogarithmicValue = ((shiftedMaxLogarithmicRangeLimit * percentage) / 100);
  const newValue = (fakePercentage * (max - min)) + min;
  // Shift logarithmic value to original logarithmic range
  // const logarithmicValue = shiftedLogarithmicValue + logarithmicMinRangeLimit;
  // Convert logarithmic value in non-logarithmic value
  // const newValue = Math.pow(powBase, logarithmicValue);
  // Round the new value based on step
  let roundedNewValue = (Math.round(newValue / step)) * step;

  if (roundedNewValue < min) {
    return min;
  }

  if (roundedNewValue > max) {
    return max;
  }

  return roundedNewValue;
}

export const convertValueToLogarithmicBehaviour = (data, curvatureCoefficient = 5) => {
  const { currentValue, min, max, step } = data;

  const percentage = getCurrentPercentageFromProgressBar(currentValue, min, max);
  // This is the magic! 
  const fakePercentage = (Math.pow(curvatureCoefficient, percentage) - 1) / (curvatureCoefficient - 1);
  // Get the new value based on the fake percentage
  const newValue = (fakePercentage * (max - min)) + min;
  // Round the new value based on step
  let roundedNewValue = (Math.round(newValue / step)) * step;

  if (roundedNewValue < min) {
    return min;
  }

  if (roundedNewValue > max) {
    return max;
  }

  return roundedNewValue;
}

export const convertValueFromLogarithmicBehaviour = (data, curvatureCoefficient) => {
  const { currentValue, min, max, step } = data;

  const fakePercentage = (currentValue - min) / (max - min);
  // Get the starting percentage based on the fake percentage
  const percentage = getBaseLog((1 + (curvatureCoefficient - 1) * fakePercentage), curvatureCoefficient);

  const newValue = getCurrentValueFromPercentage(min, max, percentage);

  // Round the new value based on step
  let roundedNewValue = (Math.round(newValue / step)) * step;

  if (roundedNewValue < min) {
    return min;
  }

  if (roundedNewValue > max) {
    return max;
  }

  return roundedNewValue;
}

// TODO: creare una funzione per gestire il caso inverso del logaritmo. Mi serve per esempio per passare il valore effettivo da cui voglio partire sullo slider al caricamento
// export const convertValueBasedOnLogaritmicScale = () => {}
export const convertLogarithmValueBasedOnLinearScale = (initialValues, options) => {
  const { currentValue, min, max, step } = initialValues;
  const { logarithmBase } = options;

  // Convert non-logarithmic value in logarithmic value
  const logarithmicValue = getBaseLog(currentValue, logarithmBase);
  const { logarithmicMinRangeLimit, shiftedMaxLogarithmicRangeLimit } = convertRangeToLogarithmicRange(min, max, logarithmBase);
  const shiftedLogarithmicValue = logarithmicValue - logarithmicMinRangeLimit;
  // Get the percentage based on the value on the logarithmic range
  const percentage = shiftedLogarithmicValue * 100 / shiftedMaxLogarithmicRangeLimit;
  // Get the value on the linear range
  const newValue = getCurrentValueFromPercentage(min, max, percentage);
  // Round the new value based on step
  let roundedNewValue = (Math.round(newValue / step)) * step;
  
  return roundedNewValue;
}

export const importPixel = (url = '', parametersObject = {}) => {
  if (url) {
    let script = document.createElement('script');
    let parameters = '';
    const keysList = Object.keys(parametersObject);
    if (typeof parametersObject === 'object' && keysList.length) {
      parameters += '?';
      keysList.forEach((key, index) => {
        if (index !== 0) {
          parameters += '&';
        }
        parameters += `${key}=${parametersObject[key]}`;
      });
    }
    script.src = `${url}${parameters}`;
    document.body.appendChild(script);
  }
}

export const getPixelData = (page = '') => {
  if( !page || page === '' ) return;

  const existentScript = document.querySelector('script[src^="https://dq.ms1222.net/52e83d65-71f0-d9ba-14af-9f10d8f0404a.png"');
  
  if (existentScript) {
    existentScript.remove();
  }
  
  importPixel(
    'https://dq.ms1222.net/52e83d65-71f0-d9ba-14af-9f10d8f0404a.png',
    {
      s: 'onsite',
      path: page,
    }
  );
}

export const returnToOrigin = (
  origin = window.location.origin
) => {
  window.location.href = origin;
}

export const getIfInternalThemeIsBaseSimulator = (internalTheme = INTERNAL_THEME.COMPASS_BASE_SIMULATOR) => {
  return internalTheme === INTERNAL_THEME.COMPASS_BASE_SIMULATOR;
}

export const getIfInternalThemeIsOneMinuteSimulator = (internalTheme = INTERNAL_THEME.COMPASS_BASE_SIMULATOR) => {
  return internalTheme === INTERNAL_THEME.COMPASS_ONE_MINUTE_SIMULATOR;
}

/**
 * 
 * @param {string | null} speedAppValue - speedApp value obtained by parameter or api
 * @returns {boolean} true if is enabled , ottherwise false
 */
export const getIfSpeedAppEnabled = (speedAppValue = null) => {
  return speedAppValue && typeof speedAppValue === "string" && speedAppValue === "S";
};